import React from "react";

function DebitIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M16.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5ZM13.125 11.25C13.125 11.4158 13.0592 11.5747 12.9419 11.6919C12.8247 11.8092 12.6658 11.875 12.5 11.875C12.3342 11.875 12.1753 11.8092 12.0581 11.6919C11.9408 11.5747 11.875 11.4158 11.875 11.25V9.00859L7.94219 12.9422C7.88412 13.0003 7.81518 13.0463 7.73931 13.0777C7.66344 13.1092 7.58212 13.1253 7.5 13.1253C7.41788 13.1253 7.33656 13.1092 7.26069 13.0777C7.18482 13.0463 7.11588 13.0003 7.05781 12.9422C6.99974 12.8841 6.95368 12.8152 6.92225 12.7393C6.89083 12.6634 6.87465 12.5821 6.87465 12.5C6.87465 12.4179 6.89083 12.3366 6.92225 12.2607C6.95368 12.1848 6.99974 12.1159 7.05781 12.0578L10.9914 8.125H8.75C8.58424 8.125 8.42527 8.05915 8.30806 7.94194C8.19085 7.82473 8.125 7.66576 8.125 7.5C8.125 7.33424 8.19085 7.17527 8.30806 7.05806C8.42527 6.94085 8.58424 6.875 8.75 6.875H12.5C12.6658 6.875 12.8247 6.94085 12.9419 7.05806C13.0592 7.17527 13.125 7.33424 13.125 7.5V11.25Z"
        fill="#FF383C"
      />
    </svg>
  );
}

export default DebitIcon;
